import yup from '../../../config/yup';

export const amazonRedshiftWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('amazonRedshiftWriter'),
  delayedRead: yup.boolean(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    username: yup.string().transform((value) => value?.trim()),
    password: yup.string().transform((value) => value?.trim()),
    rootUrl: yup.string().transform((value) => value?.trim()),
    databaseName: yup.string().transform((value) => value?.trim()),
    // JDBC properties
    tableName: yup.string().required('Table name is required'),
    driver: yup.string().required('Driver is required'),
    host: yup.string(),
    port: yup.number().typeError('Port must be a number'),
  }),
});
